<template>
  <div class="boxAddParts mt-5">
    <div class="boxAddParts_header mb-3">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="boxAddParts_header_title">
            Partes
          </h2>
        </div>
      </div>
    </div>

    <b-modal v-if="propShowModal"
             id="addPart"
             modal-class="customModal"
             body-class="customModal_body"
             header-class="modalPartes_header"
             footer-class="modalPartes_footer"
             centered
             size="xl"
             :visible="true"
             no-close-on-backdrop
             no-close-on-esc
             @hide="cleanForm">
      <div slot="modal-header"
           class="headerPartes w-100">
        Cadastro de Declarante e Testemunha
      </div>
      <b-tabs content-class=""
              class="Parte-border"
              lign="left"
              bottom
              active-nav-item-class="Parte--tab-active">
        <b-tab class="contentPartes"
               @click="formContent('parte')">
          <template v-slot:title>
            Parte
          </template>
          <form>
            <div class="form-group mt-2">
              <div v-for="(tipo, ind) in switches"
                   :key="ind"
                   class="custom-control custom-switch custom-control-inline">
                <input :id="tipo.idText"
                       :checked="(tipo.value === parte.tipo)"
                       class="custom-control-input"
                       :name="tipo.idText"
                       type="checkbox"
                       :value="tipo.value"
                       @change="changeTipo(tipo.value)"
                       @keydown.enter="changeTipo(tipo.value)">
                <label class="custom-control-label"
                       :for="tipo.idText">{{ tipo.text }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-auto">
                <div class="form-group">
                  <label class="label"
                         :for="`cpfTestemunha-${id}`">CPF da Testemunha</label>
                  <input :id="`cpfTestemunha-${id}`"
                         ref="cpf_parte"
                         v-model="parte.pessoa.cpf"
                         v-mask="`999.999.999-99`"
                         v-validate="{ regex: /\d{3}\.\d{3}\.\d{3}-\d{2}$/ }"
                         :class="{ 'is-invalid': errors.has('cpfTestemunha') }"
                         class="form-control form-control-sm"
                         name="cpfTestemunha"
                         placeholder="000.000.000-00"
                         type="tel"
                         @change="searchCPF">

                  <small v-if="errors.has('cpfTestemunha')"
                         class="invalid-feedback">{{ errors.first('cpfTestemunha') }}</small>
                </div>
              </div>

              <div class="col-12 col-sm-5">
                <div class="form-group">
                  <label class="label"
                         for="nomeTestemunha">Nome</label>
                  <input id="nomeTestemunha"
                         v-model="parte.pessoa.nome"
                         v-uppercase
                         v-validate="`required|min:2`"
                         class="form-control form-control-sm text-uppercase"
                         :class="{ 'is-invalid': errors.has('nomeTestemunha') }"
                         minlength="2"
                         name="nomeTestemunha"
                         placeholder="Jaspion da Silva"
                         required
                         type="text">
                  <small v-if="errors.has('nomeTestemunha')"
                         class="invalid-feedback">{{ errors.first('nomeTestemunha') }}</small>
                </div>
              </div>

              <div class="col-12 col-sm-3 col-xl-2">
                <div class="form-group">
                  <label class="label"
                         for="profTestemunha">Profissão</label>
                  <input id="profTestemunha"
                         v-model="parte.pessoa.ocupacao_declarada"
                         class="form-control form-control-sm"
                         name="profTestemunha"
                         placeholder="Encanador"
                         type="text">
                </div>
              </div>

              <div class="col-12 col-sm-3">
                <div class="form-group">
                  <label class="label"
                         :for="`nacionalidade_BoxParte-${idComp}`">Nacionalidade</label>

                  <Nacionalidades v-model="parte.pessoa.nacionalidade_codigo"
                                  :prop-nacionalidade="parte.pessoa.nacionalidade"
                                  @updated="changeNacionalidade" />
                </div>
              </div>

              <div class="col-12 col-sm-3">
                <div class="form-group">
                  <label class="label"
                         for="parteEstadoCivil">Estado civil</label>
                  <multiselect id="parteEstadoCivil"
                               v-model="localData.estado_civil"
                               v-on-leaving-select
                               :options="ESTADOS_CIVIL.map(est => est.name)"
                               :searchable="false"
                               :show-labels="false"
                               placeholder="Selecione"
                               @input="changeEstadoCivil" />
                </div>
              </div>
            </div>
          </form>
        </b-tab>
        <b-tab class="contentDocumentos"
               @click="formContent('documentos')">
          <template v-slot:title>
            Documentos
          </template>
          <Documentos class="mt-2"
                      :documentos="parte.pessoa.documentos"
                      @DocumentoAdded="addDocumento"
                      @DocumentoRemoved="removeDocumento" />
        </b-tab>
        <b-tab class="contentEndereco"
               @click="formContent('endereco')">
          <template v-slot:title>
            Endereço
          </template>
          <BoxEndereco :data="parte.pessoa.endereco"
                       :prop-mostrar-exterior="true"
                       :no-header="true"
                       @onEnderecoAdd="receiveAddress" />

        <!--
        <BoxMultiEnderecos :prop-enderecos="parte.pessoa.enderecos"
                           :prop-cartorio="propCartorio"
                           :prop-cpf="!!parte.pessoa.cpf"
                           @deleteAddress="deleteAddress"
                           @changed="updateAdresses" />
        -->
        </b-tab>
      </b-tabs>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <div class="row no-gutters justify-content-end align-items-center">
          <button id="btn-cancel-parte"
                  class="btn btn-sm btn-light mr-2"
                  @click="cancel">
            Voltar
          </button>
          <button id="btn-submit-parte"
                  class="btn btn-sm btn-primary"
                  type="button"
                  @click="sendPart">
            {{ parte.edit ? "Atualizar" : "Continuar" }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import BoxMultiEnderecos from '@/components/SofiaRei/BoxMultiEnderecos.vue'
  import BoxEndereco from '../BoxEndereco.vue'
  import Documentos from '@/components/SofiaRei/Obito/Passos/Sessoes/Documentos'
  import Nacionalidades from "@/components/SofiaRei/Nacionalidades"

  /* services  */
  import EnderecosService from "@/services/Enderecos"
  import PessoasService from "@/services/Pessoas"

  /* filters */
  import { filterMaskedNumber, maskCPF } from '@/filters/filters'

  /* constants  */
  import { ESTADOS_CIVIL } from "@/constants/estadosCivil"
  import Cidades from "@/constants/repositorio/cidades"


  export default {
    name: "BoxAddPartes",
    components: {
      BoxEndereco,
      Nacionalidades,
      BoxMultiEnderecos,
      Documentos
    },
    props: {
      edit: {
        type: Object,
        default: () => {}
      },
      propCartorio: {
        type: Object,
        default: () => { return {} }
      },
      propShowModal: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        id: null,
        nome: '',
        idComp: null,
        parte: {
          tipo: 'DECLARANTE',
          pessoa: {
            cpf: null,
            nome: '',
            endereco: {},
            documentos: [],
            nacionalidade_codigo: 76,
            nacionalidade: {
              nacionalidade_codigo: 76,
              nome: 'Brasil',
              nome_masculino: 'brasileiro',
              nome_feminino: 'brasileira'
            }
          },
          indicacao: null
        },
        address: {},
        switches: [{
          idText: 'parteDeclarante',
          text: 'Declarante',
          value: 'DECLARANTE'
        }, {
          idText: 'parteTestemunha',
          text: 'Testemunha',
          value: 'TESTEMUNHA'
        }, {
          idText: 'parteARogo',
          text: 'Testemunha à rogo',
          value: 'TESTEMUNHA_A_ROGO'
        }, {
          idText: 'parteSupostoPai',
          text: 'Suposto pai',
          value: 'SUPOSTO_PAI'
        }],
        ESTADOS_CIVIL,

        // Antigo
        localData: {},
        selecNacionalidadesIsLoading: false,
        selectNacionalidadesIsLoading: false,
        selectsOptions: {
          states: [],
          cities: [],
          nacionalidades: []
        },
        enderecosRemoved: []
      }
    },
    watch: {
      edit: function (newvalues) {
        let checkVal = Object.entries(newvalues)

        if (checkVal.length) {
          this.parte = {
            pessoa: { ...newvalues.pessoa },
            tipo: newvalues.tipo,
            indicacao: newvalues.indicacao,
            edit: newvalues.edicao
          }
          this.localData.estado_civil = newvalues.pessoa.estado_civil
          if (newvalues.pessoa.documentos.length) {
            this.parte.pessoa.rg = newvalues.pessoa.documentos[0].numero
          }

          this.nome = newvalues.pessoa.nome

          this.showModal = true

          if (this.parte.pessoa.cpf) {
            this.parte.pessoa.cpf = maskCPF(this.parte.pessoa.cpf)
          }
        }
      },
      nome (value) {
        this.parte.pessoa.nome = value
      },
      propShowModal () {
        if (this.propShowModal) {
          this.controlEvent().addEvent()

          setTimeout(() => {
            this.$refs.cpf_parte.focus()
          }, 100)

        }
      },
    },
    created () {
      this.selectsOptions.states = EnderecosService.getStates()
      this.selectsOptions.cities = Cidades
    },
    beforeMount () {
      this.idComp = this._uid
    },

    mounted () {
      this.init()
    },
    methods: {
      init () {
        if (this.propCartorio && this.propCartorio.endereco) {
          if (!this.parte.pessoa.nome && !this.parte.pessoa.endereco) {
            this.parte.pessoa.endereco = {
              uf: this.propCartorio.endereco.uf,
              cidade: this.propCartorio.endereco.cidade,
              ibge: this.propCartorio.endereco.ibge,
              atual: true
            }
          }
        }

        this.id = this._uid
      },
      async searchCPF () {
        let cpf = filterMaskedNumber(this.parte.pessoa.cpf)

        if (cpf && cpf.length > 10) {
          const dados = await PessoasService.getPessoaByCPF(cpf)

          if (dados.isEmpty) return

          const { nome } = dados

          this.parte.pessoa.nome = nome
        }

        this.parte.pessoa.cpf = this.parte.pessoa.cpf || null
      },
      cleanForm () {
        this.parte = {
          tipo: 'DECLARANTE',
          pessoa: {
            cpf: null,
            nome: '',
            endereco: {
              uf: this.propCartorio.endereco ? this.propCartorio.endereco.uf :  '',
              cidade: this.propCartorio.endereco ? this.propCartorio.endereco.cidade :  '',
              ibge: this.propCartorio.endereco ? this.propCartorio.endereco.ibge :  '',
              atual: true
            },
            documentos: [],
            nacionalidade_codigo: 76
          },
          indicacao: null
        }
        this.localData = {}
        this.$emit("hideModal", false)
        this.$validator.reset()
      },
      async sendPart () {
        const valid = await this.$validator.validate()

        const {errors: {items}} = this.$validator
        let emptyNumber = false

        if (items && items.length) {
          emptyNumber = !!items.find(item => item.field == 'numero' || item.field == 'codigo_ibge')
        }

        if (!valid || emptyNumber) return

        this.$validator.validateAll().then(result => {
          if (!result) return

          if (this.enderecosRemoved.length) {
            this.enderecosRemoved.forEach(endereco => {
              if (endereco.endereco_id) {
                this.$emit('removeEndereco', endereco)
              }
            })
          }

          if (Object.entries(this.edit).length) {

            let objToAdd = { ...this.edit, ...this.parte }


            this.$emit('partEdited', { objToAdd: objToAdd, indice: this.edit.indice })
          } else {
            this.$emit('sendParte', { ...this.parte })
          }

          this.$root.$emit('bv::hide::modal', 'addPart')

        })
      },
      changeTipo (tipo) {
        this.parte.tipo = tipo

        if (tipo === 'SUPOSTO_PAI') {
          this.parte.indicacao = 'NEGATIVA'
        } else {
          this.parte.indicacao = null
        }
      },
      changeEstadoCivil () {
        this.parte.pessoa.estado_civil = this.localData.estado_civil ? this.localData.estado_civil.toUpperCase() : this.localData.estado_civil
      },
      modalChanged () {},
      receiveAddress (val) {
        this.parte.pessoa.endereco = val
      },
      changeNacionalidade (nacionalidade) {
        this.parte.pessoa.nacionalidade = nacionalidade
      },
      deleteAddress (endereco) {
        this.enderecosRemoved.push(endereco)
      },
      updateAdresses (enderecos) {
        this.parte.pessoa.enderecos = enderecos
      },
      addDocumento (documento) {
        if (!this.parte.pessoa.documentos) {
          this.parte.pessoa.documentos = []
        }
        
        this.parte.pessoa.documentos.push(documento)
      },

      removeDocumento (documento) {
        this.$emit('DocumentoRemoved', documento)
        this.parte.pessoa.documentos = this.parte.pessoa.documentos.filter((doc) => doc.numero != documento.numero )
      },
      formContent (content) {
        const tabPartes = document.querySelector('.contentPartes')
        const tabDocumentos = document.querySelector('.contentDocumentos')
        const tabEndereco = document.querySelector('.contentEndereco')

        setTimeout(() => {
          switch (content) {
          case 'parte':
            tabPartes.focus()

          case 'documentos':
            tabDocumentos.focus()

          case 'endereco':
            tabEndereco.focus()
          }
        }, 200)
      },
      controlEvent () {
        const addEvent = () => {
          setTimeout(() => {
            const abas = document.querySelectorAll('.nav-link')
            const btnSubmit = document.querySelector('#btn-submit-parte')

            if (abas.length) {
              abas.forEach(aba => {
                aba.onkeydown = nextAba
              })
            }

            if (btnSubmit) {
              btnSubmit.onkeydown = firstAba
            }
          }, 100)
        }

        const nextAba = (event) => {
          if (event.key != 'Tab' && event.key != 'Enter') return

          const abas = document.querySelectorAll('.nav-link')

          const partes = document.querySelector('.contentPartes')
          const documentos = document.querySelector('.contentDocumentos')
          const endereco = document.querySelector('.contentEndereco')

          const abasArr = Array.from(abas)

          const index = abasArr.findIndex(aba => aba.id == event.target.id)

          if (index != -1 && index != abasArr.length - 1 && event.key == 'Tab') {
            setTimeout(() => {
              abas[index + 1].focus()
            }, 100)
          }

          if (event.key == 'Enter') {
            setTimeout(() => {
              const abaSelected = document.querySelector('.nav-link.active.Parte--tab-active')
              const indexSelected = abasArr.findIndex(aba => aba == abaSelected)

              switch (indexSelected) {
              case 0:
                partes.focus()

              case 1:
                documentos.focus()

              case 2:
                endereco.focus()
              }
            }, 200)
          }

        }

        const firstAba = (event) => {
          if (event.key != 'Tab') return

          const formPartes = document.querySelector('.Parte-border')
          const abas = formPartes.querySelectorAll('.nav-link')

          if (abas) {
            setTimeout(() => {
              const formPartes = document.querySelector('.Parte-border')
              const abas = formPartes.querySelectorAll('.nav-link')
              const abasArr = Array.from(abas)

              // Selecionando os primeiros campos de cada aba
              const firstInputparte = document.querySelector('#parteDeclarante')
              const firstInputDocumento = document.querySelector('.selectDocumentos')
              const firstInputEndereco = document.querySelector('.foraBrasil')

              // Obtendo a posição do index para focar no primeiro input do formulário que estiver aberto
              const abaSelected = document.querySelector('.nav-link.active.Parte--tab-active')
              const indexSelected = abasArr.findIndex(aba => aba == abaSelected)

              switch (indexSelected) {
              case 0:
                firstInputparte.focus()

              case 1:
                firstInputDocumento.focus()

              case 2:
                firstInputEndereco.focus()
              }
            }, 100)

          }
        }

        return { addEvent, nextAba, firstAba }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .boxAddParts {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }
  .headerPartes {
    background-color: #074f7f;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0.625rem 1.25rem;
  }

  .modalPartes {
    &_header {
      padding: 0 0;
    }

    &_footer {
      border:none;
    }
  }

  .Parte {
    & .nav-link {
      border: 1px solid $sinoreg-blue !important;
      color: $color-black;
      font-size: pxToRem(15);
      border-top-left-radius:0;
      border-top-right-radius:0;
    }

    &--tab-active {
      background-color: $sinoreg-blue !important;
      border: 1px solid $sinoreg-blue !important;
      color: white !important;
      fill: white !important;
      font-weight: bold;
    }

    &-border ul.nav {
      border-bottom: 3px solid $sinoreg-blue !important;
    }

    &-border ul.nav > li.nav-item > a {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius:5px;
      border-top-right-radius:5px;
      color: black;
      font-size: pxToRem(15);
    }

    &-border ul.nav > li.nav-item > a:hover {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius:5px;
      border-top-right-radius:5px;
    }
  }
</style>
